/**
 * Table order item filters helper.
 * Filters and extracts items by type (new vs sent).
 */

/**
 * Filter new items (items that are not sent to POS)
 * @param {Array} items - Cart items
 * @returns {Array} New items (isSent !== true)
 */
export function getNewItems(items) {
  return (items || []).filter((item) => item.isSent !== true);
}

/**
 * Filter sent items (items that have been sent to POS)
 * @param {Array} items - Cart items
 * @returns {Array} Sent items (isSent === true)
 */
export function getSentItems(items) {
  return (items || []).filter((item) => item.isSent === true);
}
